var React = require('react');

function CheckEmpty (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_275_14348)","key":0},React.createElement("rect",{"x":"0.5","y":"0.5","width":"15","height":"15","rx":"1.5","stroke":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_275_14348"},React.createElement("rect",{"width":"16","height":"16","fill":"currentColor"})))]);
}

CheckEmpty.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckEmpty;

CheckEmpty.default = CheckEmpty;
